import React, { useEffect, useRef, useState } from 'react';

export default function CustomSelect({ label, value, options, onChange, valueClassName }) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    function handleClickOutside(event) {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const selectedLabel = options.find((opt) => opt.value === value)?.label ?? value;

  return (
    <div className="custom-select-wrap" ref={wrapRef}>
      <button
        type="button"
        className={`custom-select-trigger ${isOpen ? 'is-open' : ''}`}
        onClick={() => setIsOpen((open) => !open)}
      >
        {label ? <span className="custom-select-label">{label}</span> : null}
        <span className={`custom-select-value ${valueClassName || ''}`}>{selectedLabel}</span>
        <span className="custom-select-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>
      {isOpen ? (
        <div className="custom-select-dropdown">
          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`custom-select-option ${opt.value === value ? 'is-active' : ''}`}
              onClick={() => {
                onChange(opt.value);
                setIsOpen(false);
              }}
            >
              {opt.label}
              {opt.value === value ? <span className="custom-select-check">✓</span> : null}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
